import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/travis/build/GogoWwz/TMagic/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import DemoBlock from '../DemoBlock/DemoBlock.tsx';
import Button from './button.tsx';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "button"
    }}>{`Button`}</h1>
    <h3 {...{
      "id": "类型"
    }}>{`类型`}</h3>
    <Playground __position={0} __code={'<DemoBlock>\n  <Button>Default</Button>\n  <Button type=\"primary\">Primary</Button>\n  <Button type=\"success\">Success</Button>\n  <Button type=\"warning\">Warning</Button>\n  <Button type=\"danger\">Danger</Button>\n  <Button type=\"link\">Link</Button>\n</DemoBlock>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      DemoBlock,
      Button,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <DemoBlock mdxType="DemoBlock">
    <Button mdxType="Button">Default</Button>
    <Button type="primary" mdxType="Button">Primary</Button>
    <Button type="success" mdxType="Button">Success</Button>
    <Button type="warning" mdxType="Button">Warning</Button>
    <Button type="danger" mdxType="Button">Danger</Button>
    <Button type="link" mdxType="Button">Link</Button>
  </DemoBlock>
    </Playground>
    <h3 {...{
      "id": "尺寸"
    }}>{`尺寸`}</h3>
    <Playground __position={1} __code={'<DemoBlock>\n  <Button size=\"large\">large</Button>\n  <Button>normal</Button>\n  <Button size=\"small\">small</Button>\n</DemoBlock>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      DemoBlock,
      Button,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <DemoBlock mdxType="DemoBlock">
    <Button size="large" mdxType="Button">large</Button>
    <Button mdxType="Button">normal</Button>
    <Button size="small" mdxType="Button">small</Button>
  </DemoBlock>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      